export default {
  en: {
    confirmRepaymentAmount: 'Submit a repayment request for loan #{order} for {amount}? Your balance will remain unchanged until an administrator approves it.',
    repaymentProcessing: 'Submitting repayment request...'
  }
}
